import Amplify, { Auth } from "aws-amplify";
import { Signer } from "@aws-amplify/core";

const endPointHospi = process.env.REACT_APP_AWS_ENDPOINT;

export const initAmplify = (): void => {
  Amplify.configure({
    Auth: {
      identityPoolId: process.env.REACT_APP_POOL_ID,
      region: process.env.REACT_APP_REGION,
      identityPoolRegion: process.env.REACT_APP_REGION,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_WEB_CLIENT_ID,
    },
    API: {
      endpoints: [
        {
          name: "UsersProfile",
          endpoint: endPointHospi,
          region: process.env.REACT_APP_REGION,
        },
        {
          name: "HostHouse",
          endpoint: endPointHospi,
          region: process.env.REACT_APP_REGION,
        },
        {
          name: "StudentHouse",
          endpoint: endPointHospi,
          region: process.env.REACT_APP_REGION,
        },
        {
          name: "StudentMatches",
          endpoint: endPointHospi,
          region: process.env.REACT_APP_REGION,
        },
        {
          name: "HostMatches",
          endpoint: endPointHospi,
          region: process.env.REACT_APP_REGION,
        },
        {
          name: "UserChats",
          endpoint: endPointHospi,
          region: process.env.REACT_APP_REGION,
        },
      ],
    },
  });
};

export const getAutorizationToken = async (): Promise<string> => {
  // console.log((await Auth.currentSession()).getIdToken().getJwtToken())
  return (await Auth.currentSession()).getIdToken().getJwtToken();
};

export const getHeaderAuth = async () => ({
  Authorization: `Bearer ${await getAutorizationToken()}`,
});

export const initData = async (): Promise<RequestInit> => ({
  headers: await getHeaderAuth(),
});

export const getSignedUrl = async () => {
  const credentials = await Auth.currentCredentials();
  if (!credentials.accessKeyId) { throw Error('User is not authorized') }
  const accessInfo = {
    access_key: credentials.accessKeyId,
    secret_key: credentials.secretAccessKey,
    session_token: credentials.sessionToken,
  };

  return Signer.signUrl(process.env.REACT_APP_WEBSOCKET, accessInfo);
};

export const clearLocalStorage = () => {
  const arrayItem: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    if (localStorage.key(i)?.startsWith("Cognito"))
      arrayItem.push(localStorage.key(i) ?? "");
  }
  arrayItem.filter(Boolean).forEach((item) => localStorage.removeItem(item));
};
